
export default {
  campaignCreatorTitle: "منشئ حملة فيوجن",
  campaignDetails: "تفاصيل الحملة",
  creativeContent: "المحتوى الإبداعي",
  creativeAssets: "الأصول الإبداعية",
  supportedImageFormats: "تنسيقات الصور المدعومة: JPG, JPEG, PNG, GIF",
  supportedVideoFormats: "تنسيقات الفيديو المدعومة: MP4, MPEG, 3GP, AVI, MOV",
  bestDisplayResolution: "أفضل دقة عرض: 1080x1920 بكسل",
  dragAndDrop: "اسحب الملفات وأفلتها هنا أو انقر للتصفح",
  multipleFilesSupported: "يمكنك تحميل ملفات متعددة",
  remove: "إزالة",
  exampleAdvertisements: "أمثلة للإعلانات",
  seeHowAds: "شاهد كيف ستبدو إعلاناتك على أجهزتنا",
  uploadCreative: "تحميل التصميم",
  customizeYourCampaign: "تخصيص حملتك",
  campaignCustomizeDescription: "الآن أعط حملتك اسمًا للتعرف عليها بسهولة وقم بتحميل الإبداعات الخاصة بك.",
  campaignName: "اسم الحملة",
  enterCampaignName: "أدخل اسم حملتك",
  campaignNameHelp: "لمساعدتك في التعرف على حملتك بسهولة",
  dimensions: "الأبعاد",
  material: "المواد",
  width: "العرض",
  height: "الارتفاع",
  pleaseUploadCorrectDimensions: "يرجى تحميل الأبعاد الصحيحة ليتم عرض الإعلان بشكل صحيح",
  others: "أخرى",
  dropImageOrVideo: "اسحب الصورة أو الفيديو هنا، أو",
  browse: "استعرض",
  uploading: "جاري التحميل...",
  uploadDifferentContent: "تحميل محتوى مختلف لكل موقع",
  takeYourDesignToNextLevel: "خذ تصميمك إلى المستوى التالي",
  designTipsDescription: "إليك بعض النصائح لأخذ تصميمك إلى المستوى التالي حتى يستفيد جمهورك بأقصى قيمة منه",
  locationSpecificContent: "محتوى خاص بالموقع",
  mediaOwnerSpecificContent: "محتوى خاص بمالك الوسائط",
  noMediaOwnersAvailable: "لا يوجد مالكي وسائط متاحين",
  
  // Upload options
  uploadOptions: "خيارات تحميل الإبداعات",
  sameContentAll: "استخدام نفس المحتوى لجميع المواقع",
  differentContentLocation: "استخدام محتوى مختلف لكل موقع",
  differentContentMediaOwner: "استخدام محتوى مختلف لكل مالك وسائط",
  
  // Design Tips
  cultureRelevance: "الملاءمة الثقافية",
  cultureRelevanceNote: "قم بتضمين صور ورسائل تتناسب مع الثقافة المحلية للمواقع المستهدفة. الإعلانات المرتبطة ثقافياً تؤدي أداءً أفضل بنسبة 30٪ من المحتوى العام.",
  visualClarity: "الوضوح البصري",
  visualClarityNote: "حافظ على تصميم نظيف مع نص عالي التباين على خلفيات مناسبة. تذكر أن المشاهدين سيرون إعلانك لبضع ثوانٍ فقط، لذا فإن الوضوح ضروري للاحتفاظ بالرسالة.",
  callToAction: "دعوة مقنعة للعمل",
  callToActionNote: "كل إعلان فعال يحتاج إلى دعوة واضحة للعمل. أخبر جمهورك بالضبط بما تريد منهم فعله بعد ذلك - سواء كان زيارة موقعك الإلكتروني، أو الاتصال برقم، أو زيارة موقعك.",
} as const;
